module.exports = {
    all:'合作完成',
    stop:'合作终止',
    ing:'合作中',
    operate:'操作',
    price:'成本价格',
    payment:'支付方式',
    schedule:'预估档期',
    remarks:'备注',
    cancelSuccess:'流程中断成功',
    cancelFail:"流程中断失败",
    baiscinfo:'基本信息',
    Client:'广告主',
    Product:'产品',
    Country:'国家',
    templeteInfo:'模板信息',
    adds:'',
    newsugges:'需要您填写对脚本的修改意见',
    newsugges2:'需要您填写对内容的修改意见',
    Brief:'推广需求',
    Brief2:'推广需求',
    exchange:'免费置换',
    campaignName:'推广活动名称',
    ohters:'其他',
    ctu:'点击上传文件',
    uploadreportNone:'上传报告不能为空',
    Submit:'提交',
    sor_stop:'很遗憾，您已终止合作',
    need_more:'如需再次合作，请联系您的商务经理',
    ecom:'电子商务',
    game:'游戏',
    fgp:'针对于游戏产品',
    marketing:'项目名称',
    marketings:'项目名称',
    fecp:'针对于电子商务产品',
    rlc:'创建新流程',
    spn:'查询产品名',
    uploads:'上传脚本',
    completedUploadedFiles:'视频上传完成数',
    id:'序号',
    current:'当前进度',
    full:'全流程',
    proname:'产品名称',
    blf:'推广链接',
    kltbc:'待确认网红列表',
    advprice:'预估价格',
    advprice2:'合作价格',
    upoe:'上传下单邮件',
    kl:'网红列表',
    addkol:'增加网红',
    intentList:'意向清单',
    confirmEmail:'请确认下单邮件',
    kolcontract:'网红合同上传',
    address:'地址',
    pamentc:'付款凭证上传',
    jiaobens:'内容',
    status:'状态',
    uptime:'上传时间',
    invoiceIfo:'Invoice信息上传',

    city:'城市',
    idCode:'身份证号',
    zip:'邮编',
    phone:'电话',
    pia:'请填写地址',
    pic:'请填写城市',
    pitrackLink:'请输入快递单号查询链接',
    pitrackingNum:'请输入快递单号',
    pisampleModel:'请输入寄送样品型号',
    piidCode:'请输入身份证号',
    pis:'请填写洲名',
    pico:'请填写国家',
    piz:'请填写邮编',
    pip:'请填写电话号码',
    kolinfo:'网红信息',
    kolname:'网红名',
    dress:'地址',
    ncri:'需要客户填写信息',
    otherInfo:'其他信息',
    t1:'请选择',
    t3:'请选择',
    t2:'请选择',
    xx:'源文件上传',
    picor:"（图片/视频）",
    proInfos:'产品资料',
    rq:'发布要求',
    logistics:'物流信息',
    zero:'',
    one:'',
    two:'',
    three:'',
    four:'',
    five:'',
    six:'',
    seven:'',
    eight:'',
    nine:'',
    ten:'',
    0:'意向网红确认',
    1:'下单执行',
    2:'下单执行',
    3:"网红合同敲定",
    4:'物料支持',
    5:'产品试用',
    6:'脚本审核',
    7:'内容审核 ',
    8:'内容发布',
    9:'结案报告',
    10:'录入网红信息',


    Entry:'录入',
    Kol_Info:'录入网红信息',
//     意向网红确认 -  Intention Confirm
// 运营确认意向网红 - Intention Confirm(YM)
// 客户下单执行 - Order Execution
// 网红合同敲定 - KOL’s Contract Signing
// 物料支持 - Material Support
// 样品签收&试用 Sample Receipt&Trial
// 脚本审核 - Script Review
// 视频审核 - Video Review
// 内容发布 - Content Issue
// 结案报告 - Closing Report
    Confirmations:'意向网红确认',
    Confirmation:'下单执行',
    Execution:'下单执行',
    Signing:'网红合同敲定',
    Support:'物料支持',
    Receipt:'产品试用',
    Script:'脚本审核',
    Video:'内容审核 ',
    Issue:'内容发布',
    Report:'结案报告',
    step:'步骤',
    uploadNone:'上传文件不能为空',
    materialwaite:'物料需求整理中，请稍等',
    opration_after:'正在确认您上传的信息，请稍等',
    addempty:'国家,城市,地址,电话不能为空',
    waieadvmeterial:'广告主正在填写材料，请稍等',
    bloggerget:'网红是否开始试用产品？',
    bloggerdoing:'博主样品确认中',
    bloggerrecive:'博主如果收到产品，请点击下方按钮',
    bloggersure:'博主正在确认产品，请您耐心等待',
    havegetSimle:'网红已开始试用产品',
    got:'知道了',
    sure:'是',
    contentnone:"上传内容不能为空",
    jiaoben:'脚本上传',
    jiaobeninput:'脚本链接录入',
    jiaobenrecord:'脚本上传记录',
    filesuggest:'建议上传文件小于200M',
    jiaobens2:'脚本',
    sugg:'意见',
    waitadv:'正在等待广告主审核',
    waitVideo:'正在等待运营上传内容',
    shi:'是',
    videos:'内容',
    videoup:'内容上传',
    videouprecord:'内容上传记录',
    novideo:'暂无视频或图片',
    wacv:'正在等待广告主审核内容',
    feedbacks:'需要您填写对内容的修改意见',
    operLik:'推广结果上传中，请稍侯',
    advLink:'推广结果确认中，请稍候',
    linksno:'链接不能为空',
    itsr:'该流程的结案报告是否上传？',
    tcriup:'结案报告正在努力制作中，请您耐心等待',
    hbctcr:'结案报告已制作完成请前往报告库查看',
    see:'去查看',
    shenpi:'审批',
    timeSet:'设置预估结束时间',
    rejecthave:'已驳回',
    jivwoe:'该流程的结案报告已经上传',
    savelink:'保存链接',
    aipkw:'广告主正在挑选网红，请稍等',
    wfewidvji:'等待运营与您确认下单邮件',
    waitesie:'脚本正在制作中，请耐心等待',
    pubf:'请上传推广需求文件',
    linkss:'链接',
    beizhu:'备注',
    pckf:'请选择网红文件夹',
    pcadv:'请填写基础信息',
    pcproduct:'请选择产品',
    pcCountry:'请选择国家',
    pctemplete:'请选择模板信息',
    kolic:'网红意向确认',
    fp:'全流程',
    choosekol:'您至少需要选择一个网红',
    nochoose:'客户需要填写的信息不能为空',
    submitok:'提交成功',
    Reject:'驳回',
    Paypal:'Paypal',
    Wire:'银行卡转账',
    notbefore:'起始日期不能早于今天',
    pro:'产品资料',
    release:'发布要求',
    logs:'物流信息',
    chfis:'请先选择广告主',
    advname:'广告主名称',
    productname:'产品名称',
    plip:'产品名称查询',
    mlip:'项目名称查询',
    exists:'此项目名称在流程中在使用状态,无法被删除',
    repeats:'产品名称重复',
    mar_repeats:'项目名称重复',
    havesamekols:'相同产品国家广告主下，网红不能重复',
    moretwo:'最多上传两个文件',
    pipn:'请输入产品名称',
    pimn:'请输入项目名称',
    waitConfirm:'待确认网红列表',
    saves:'新增保存',
    psanew:'请选择广告主',
    links:'预览链接',
    piap:'请输入产品名称',
    pdcbe:'产品资料不能为空',
    rrcbe:'发布要求不能为空',
    licbe:'物流信息不能为空',
    moretoFive:'文件最多上传5个',
    ncu:'不是正确的URL',
    Agree:'同意',
    addlink:'添加预览链接',
    addlinkdesc:'备注信息',
    noaut:'没有操作权限',
    sampleModel:'寄送样品型号',
    trackingNum:'快递单号',
    trackLink:'快递单号查询链接',
    channel:'渠道',
    influencerArea:'受众国家',
    totalVideos:'视频数',
    mustfill:'被勾选的列,数据不能为空',
    subscribers:'粉丝数',
    cartTitle:'网红购物车',
    createChildren:'正在努力生成子流程...',
    suggs:'可以提供一些脚本的反馈意见吗？',
    collaborator:'负责人',
    nosupport:'当前文件格式不支持在线预览',
    datafinish:'预计交付时间：',

    addtoco:'从收藏夹添加',
    init:'基础信息完善',
    mp_submited:'意向确认',
    cust_approved:'MP确认',
    campaign_start :'已下单',
    cust_reject:'拒绝确认',
    mp_reject:'运营已拒绝',
    remove:'删除',
    submit_t:'确认提交',
    start_order:'确认执行',
    cancel:'取消',
    haveexist:'表格中已存在URL,请重新修改',
    kol_a:'网红性质',
    note:'备注信息',
    mcn:'MCN',
    individual:'个人',
    broker:'经济人',
}


// WEBPACK FOOTER //
// ./src/i18n/modules/koltrack/zh-cn.js